import { defineComponent as o, openBlock as i, createBlock as r, unref as n, withCtx as a, createElementVNode as f } from "vue";
import l from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as s } from "@storefront-ui/shared";
const u = /* @__PURE__ */ o({
  __name: "SfIconFavoriteFilled",
  props: {
    size: {
      type: String,
      default: s.base
    }
  },
  setup(t) {
    return (m, e) => (i(), r(n(l), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "favorite-filled"
    }, {
      default: a(() => e[0] || (e[0] = [
        f("path", { d: "M10.67 21.133c-5.52-4.95-8.72-7.64-8.67-11.39.04-2.97 2.3-4.39 2.35-4.43 3.61-2.46 6.89.22 7.65 1.11.75-.88 3.99-3.51 7.56-1.16.52.34 2.23 1.65 2.42 4.12.32 4.28-4.14 7.76-8.65 11.76-.38.34-.86.5-1.34.5-.47 0-.94-.17-1.32-.51" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
